import Swiper from "swiper/bundle";

/**
 * 指定したDOM要素が特定のクラスを含んでいるかどうかをチェックする関数。
 * @param {Element} element - チェックするDOM要素。
 * @param {Array<string>} classes - チェックするクラス名の配列。
 * @param {boolean} isAnd - 条件のロジック。trueなら`and`、falseなら`or`。
 * @returns {boolean} 条件に合致する場合はtrue、そうでない場合はfalse。
 */
const hasClasses = (element, classes, isAnd = false) => {
    const classList = element.classList;
    return isAnd
        ? classes.every((cls) => classList.contains(cls))
        : classes.some((cls) => classList.contains(cls));
};

if (hasClasses(document.body, ["page", "company"], true)) {
    const boxes = document.querySelectorAll(".company__containerBlockBox");

    boxes.forEach((box) => {
        let swiper = new Swiper(
            box.querySelector(".company__containerBlockBoxFigSlider"),
            {
                simulateTouch: false,
            }
        );

        const thumbs = box.querySelectorAll(
            ".company__containerBlockBoxFigThumItem"
        );

        thumbs.forEach((li, index) => {
            if (index == 0) {
                li.classList.add("active");
            }
            li.addEventListener("click", (e) => {
                e.preventDefault();
                thumbs.forEach((li, index) => {
                    li.classList.remove("active");
                });

                li.classList.add("active");
                swiper.slideTo(index);
            });
        });
    });
}
